import React from 'react';

const DailyRakeback = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.75046 3.24899V1.5002H6.25117V3.24899H3.00113C2.03509 3.24899 1.25195 4.03212 1.25195 4.99816V18.9916C1.25195 21.0617 2.9301 22.7398 5.00019 22.7398H18.9936C21.0637 22.7398 22.7418 21.0617 22.7418 18.9916V4.99816C22.7418 4.03212 21.9587 3.24899 20.9926 3.24899H17.7442V1.5002H16.2449V3.24899H7.75046ZM16.2449 6.49784V4.74828H7.75046V6.49784H6.25117V4.74828H3.00113C2.86312 4.74828 2.75125 4.86016 2.75125 4.99816V8.24704H21.2425V4.99816C21.2425 4.86016 21.1306 4.74828 20.9926 4.74828H17.7442V6.49784H16.2449ZM21.2425 9.74633H2.75125V18.9916C2.75125 20.2336 3.75813 21.2405 5.00019 21.2405H18.9936C20.2356 21.2405 21.2425 20.2336 21.2425 18.9916V9.74633Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.5625 11.9953H13.6884L8.44073 18.9922H10.3148L15.5625 11.9953ZM10.5044 13.4953C10.5044 14.3233 9.83319 14.9946 9.00515 14.9946C8.17712 14.9946 7.50586 14.3233 7.50586 13.4953C7.50586 12.6673 8.17712 11.996 9.00515 11.996C9.83319 11.996 10.5044 12.6673 10.5044 13.4953ZM16.4998 17.4931C16.4998 18.3212 15.8285 18.9924 15.0005 18.9924C14.1724 18.9924 13.5012 18.3212 13.5012 17.4931C13.5012 16.6651 14.1724 15.9938 15.0005 15.9938C15.8285 15.9938 16.4998 16.6651 16.4998 17.4931Z",
      fill: "white"
    }
  )
);

export { DailyRakeback };
//# sourceMappingURL=DailyRakeback.js.map
